import React from 'react';
import { UserList } from '@saleshandy/icons';

const BlueUserList = () => (
  <UserList width={16} height={16} className="blue-txt-11" />
);

export default BlueUserList;
